import React, { useState } from 'react';
import { PageHead } from './finance/shared';
import { NewMessageTab } from './communication/NewMessageTab';
import { BulkSendTab } from './communication/BulkSendTab';
import { LogTab } from './communication/LogTab';
import { TemplatesSettingsTab } from './communication/TemplatesSettingsTab';

// صفحة «التواصل» — رسائل واتساب جاهزة عبر روابط wa.me فقط، بلا API خارجي وبلا إرسال آلي
export default function CommunicationPage() {
  const [tab, setTab] = useState('new');
  const tabs = [
    ['new', 'رسالة جديدة'],
    ['bulk', 'الإرسال المتتابع'],
    ['log', 'سجل الرسائل'],
    ['templates', 'القوالب والإعدادات'],
  ];

  return (
    <div className="mx-auto max-w-6xl space-y-4" dir="rtl" data-testid="communication-page">
      <PageHead title="التواصل" desc="رسائل واتساب جاهزة تراجعها ثم تفتحها وترسلها بنفسك — بلا إرسال آلي" />
      <div className="flex gap-1 rounded-xl border border-slate-200 bg-white p-1 overflow-x-auto" data-testid="communication-tabs">
        {tabs.map(([k, v]) => (
          <button
            key={k}
            onClick={() => setTab(k)}
            data-testid={`communication-tab-${k}`}
            className={`flex-1 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${tab === k ? 'bg-[#16233b] text-white' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            {v}
          </button>
        ))}
      </div>
      {tab === 'new' && <NewMessageTab />}
      {tab === 'bulk' && <BulkSendTab />}
      {tab === 'log' && <LogTab />}
      {tab === 'templates' && <TemplatesSettingsTab />}
    </div>
  );
}
